module.exports = __webpack_public_path__ + "img/logo111.1d924979.png";